import { Component } from '@angular/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-challenges-page',
  templateUrl: './challenges-page.component.html',
  styleUrl: './challenges-page.component.scss',
})
export class ChallengesPageComponent {
  populations = Populations;
}
